export default __webpack_public_path__ + "static/media/hourglass.a9eb3952.svg";